export const strings = {
  required: '{field} is required',
  min_length: '{field} has to be min {length} characters',
  max_length: '{field} cannot be more than {length} characters',
};
